import React from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { AuthContext } from '../../authContext.js';
import useTokenStorage from '../useTokenStorage.js';
export const useLogout = ({ onLogout } = {}) => {
    const { forgetAuthToken } = useTokenStorage();
    const { setIdentity, setToken } = React.useContext(AuthContext);
    const logout = useCallbackRef(() => {
        forgetAuthToken();
        setToken(null);
        setIdentity((prevState) => ({
            ...prevState,
            user: undefined,
        }));
        onLogout?.();
    });
    return logout;
};
